import { render, staticRenderFns } from "./AddPatientDiagnosisModal.vue?vue&type=template&id=1b5c7fc6&"
import script from "./AddPatientDiagnosisModal.vue?vue&type=script&lang=js&"
export * from "./AddPatientDiagnosisModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPatientDiagnosisModal.vue?vue&type=style&index=0&id=1b5c7fc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports